<script setup lang="ts">
import type { SliceInterface } from '@voix/types'
import type { Ref } from 'vue'
import PageReleaseSelect from '@voix/components/chrome/pages/PageReleaseSelect.vue'
import { copyElement } from '@voix/composables/queries/useQueryElements'
import { useVoixToast } from '@voix/composables/useVoixToast'
import { ref } from 'vue'

const props = defineProps<{
  slice: SliceInterface
}>()

const emit = defineEmits(['close'])
const page: Ref<{ id?: string, title?: string, release_id?: string, release_label?: string }> = ref({})
const voixToast = useVoixToast()

async function copyToPage() {
  if (page.value && props.slice) {
    await copyElement({
      page_id: page.value.id,
      release_id: page.value.release_id,
      ...props.slice,
    }).then(() => {
      voixToast.add(`Slice copied to ${page.value.title}`, 'msg')
    }).catch((err: { message: any }) => {
      voixToast.add(err.message, 'error')
    })

    page.value = {}
    emit('close')
  }
}
</script>

<template>
  <div>
    <div class="text-xs uppercase font-medium voix-admin-text">
      Copy this slice to a page
    </div>

    <PageReleaseSelect v-model="page" label="Page to copy to" class="mt-4" />

    <AdministrationAlert v-if="page?.id" type="info" class="mt-2 text-2xs font-medium uppercase text-gray-500">
      <span class="text-gray-400">Current Page Selected:</span>
      {{ page.title }}
      <span v-if="page.release_id">: {{ page.release_label }}</span>
      <span v-else>: Live</span>
    </AdministrationAlert>

    <div class="flex space-x-2 mt-4 ">
      <button
        class="voix-admin-bg text-white px-4 py-2 rounded-sm text-xs disabled:opacity-20 disabled:cursor-not-allowed"
        :disabled="!page"
        @click="copyToPage"
      >
        Copy
      </button>

      <button class=" bg-gray-200 text-gray-600 px-4 py-2 rounded-sm text-xs" @click="$emit('close')">
        Cancel
      </button>
    </div>
  </div>
</template>
